module.exports = __webpack_public_path__ + "static/media/room-1.a1403e90.jpeg";